/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import { OnShowAssetPickerProps } from '../../helpers/types'
import { DesktopStandard, MobileStandard } from './displays'
import { styles } from './styles'

interface Props {
  accountName: string
  accountUsername: string
  bio: string
  coverImage: AssetReference | null
  display: string
  isPresenting?: boolean
  location: string
  onDragDrop?: (
    e: React.DragEvent<HTMLDivElement>,
    args: OnShowAssetPickerProps
  ) => void
  onExpandAsset?: (assetId: number) => void
  onRemoveAsset?: (assetId: number) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  postType: string
  profileImage: AssetReference | null
  readOnly: boolean
  truncate: boolean
  url: string
  updateText?: (val: string, destination: string) => void
}

const displays: { [key: string]: React.FC<any> } = {
  default: MobileStandard,
  desktopStandard: DesktopStandard,
  mobileStandard: MobileStandard,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const TwitterPageUpdate: React.FC<Props> = ({
  accountName,
  accountUsername,
  bio,
  coverImage,
  display,
  isPresenting,
  location,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  postType,
  profileImage,
  readOnly,
  truncate,
  url,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)

  return (
    <div
      css={styles.getDisplay(display)}
      className={kuiperClassNames(
        'twitter twitter-page-update',
        `twitter-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountUsername={accountUsername}
        bio={bio}
        accountName={accountName}
        coverImage={coverImage}
        display={display}
        isPresenting={isPresenting === undefined ? false : isPresenting}
        location={location}
        truncate={truncate}
        onDragDrop={onDragDrop ? onDragDrop : doNothing}
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onInputChange={updateText ? updateText : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
        postType={postType}
        profileImage={profileImage}
        readOnly={readOnly}
        url={url}
      />
    </div>
  )
}
